<template>
  <CRow>
    <CCol>
      <CCard>
        <CCardHeader>
          <strong>Tạo danh mục linh kiện</strong>
          (tạo định dạng danh mục dùng cho mua hàng hoặc nhập kho)
          <div class="card-header-actions">
            <CButton
              color="info"
              shape="pill"
              @click="createBuyBom">
              <CIcon name="cil-cloud-download" class=""/>
              Tạo danh mục
            </CButton>
          </div>
        </CCardHeader>
      </CCard>
      <CCard>
        <CCardHeader class="pb-0 mb-0">
          <strong>Nhập kho linh kiện theo thông tin từ tệp</strong>
          <p>Định dạng tệp excel phải gồm các cột: Nhóm linh kiện | EES CODE |	Mô tả	| Mã |	NSX	| Số lượng</p>
        </CCardHeader>
        <CCardBody>
          <CRow>
            <CCol sm="6" md="8" lg="9">
              <label
                class="form-control"
                for="fileInputImport"
              >{{ fileNameImport }}
              </label>
              <input type="file"
                     accept=".xls,.xlsx"
                     id="fileInputImport"
                     style="display: none;"
                     @change="onFileChangeImport">
            </CCol>
            <CCol sm="6" md="4" lg="3">
              <CButton shape="pill" color="info"
                       style="width: 100%;" @click="handleSubmitImport"
                       :disabled="isUploadingImport"
              >
                <CIcon name="cil-cloud-upload"/>
                {{ isUploadingImport ? "Đang tải..." : "Tải lên" }}
              </CButton>
            </CCol>
          </CRow>
          <CRow v-if="isUploadingImport" class="justify-content-center" style="margin-top: 20px">
            <CSpinner
              color="info"
              style="width:2rem;height:2rem;"
            />
          </CRow>
        </CCardBody>
      </CCard>
      <CCard>
        <CCardHeader class="pb-0 mb-0">
          <strong>Xuất kho linh kiện theo thông tin từ tệp</strong>
          <p>Định dạng tệp excel phải gồm các cột: Nhóm linh kiện | EES CODE |	Mô tả	| Mã |	NSX	| Số lượng</p>
        </CCardHeader>
        <CCardBody>
          <CRow>
            <CCol sm="6" md="8" lg="9">
              <label
                class="form-control"
                for="fileInputExport"
              >{{ fileNameExport }}
              </label>
              <input type="file"
                     accept=".xls,.xlsx"
                     id="fileInputExport"
                     style="display: none;"
                     @change="onFileChangeExport">
            </CCol>
            <CCol sm="6" md="4" lg="3">
              <CButton shape="pill" color="info"
                       style="width: 100%;" @click="handleSubmitExport"
                       :disabled="isUploadingExport"
              >
                <CIcon name="cil-cloud-upload"/>
                {{ isUploadingExport ? "Đang tải..." : "Tải lên" }}
              </CButton>
            </CCol>
          </CRow>
          <CRow v-if="isUploadingExport" class="justify-content-center" style="margin-top: 20px">
            <CSpinner
              color="info"
              style="width:2rem;height:2rem;"
            />
          </CRow>
        </CCardBody>
      </CCard>
      <CCard v-if="isSuper">
        <CCardHeader>
          <strong style="color:red;">Tạo linh kiện từ tệp</strong> (chú ý: định dạng tệp phải theo quy định)
        </CCardHeader>
        <CCardBody>
          <CRow>
            <CCol sm="6" md="8" lg="9">
              <label
                class="form-control"
                for="fileInput"
                >{{ fileNameTemplate }}
              </label>
              <input type="file"
                id="fileInput"
                accept=".xls,.xlsx"
                style="display: none;"
                @change="onFileChangeTemplate">
            </CCol>
            <CCol sm="6" md="4" lg="3">
              <CButton shape="pill" color="info"
               style="width: 100%;" @click="handleSubmitTemplate"
               :disabled="isUploadingTemplate"
              >
                <CIcon name="cil-cloud-upload"/>
                {{ isUploadingTemplate ? "Đang tải..." : "Tải lên" }}
              </CButton>
            </CCol>
          </CRow>
          <CRow v-if="isUploadingTemplate" class="justify-content-center" style="margin-top: 20px">
            <CSpinner
              color="info"
              style="width:2rem;height:2rem;"
            />
          </CRow>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
export default {
  data() {
    return {
      fileNameImport: 'Duyệt tệp',
      selectedFileImport: null, // Holds the selected file object
      isUploadingImport: false,
      fileNameExport: 'Duyệt tệp',
      selectedFileExport: null, // Holds the selected file object
      isUploadingExport: false,
      fileNameTemplate: 'Duyệt tệp',
      selectedFileTemplate: null, // Holds the selected file object
      isUploadingTemplate: false,
      isSuper: false,
    };
  },
  created() {
    const role = localStorage.getItem('role')
    this.isSuper = ((role === 'root') || (role === 'super'))
  },
  methods: {
    handleSubmitTemplate() {
      if (!this.selectedFileTemplate) {
        this.$swal.fire({
          icon: "error",
          title: "Tải lên",
          text: "Vui lòng chọn tệp trước"
        });
        return;
      }

      this.$swal.fire({
        title: "Nhập thao tác",
        input: "text",
        inputPlaceholder: "Nhập thao tác...",
        showCancelButton: true,
      }).then((result) => {
        if (result.isConfirmed && result.value) {
          if (result.value.toLowerCase() !== 'template') {
            this.$swal.fire({
              icon: "error",
              title: "Nhập thao tác",
              text: "Thao tác không hợp lệ!"
            });
          } else {
            // Create FormData instance to hold the file
            this.isUploadingTemplate = true;
            const formData = new FormData();
            formData.append("file", this.selectedFileTemplate);
            // Send file using Axios
            this.$request.post("/api/repo/template", formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
              .then((res) => {
                if (res.data.status === 'success') {
                  // console.log(res.data.status)
                  this.$swal.fire({
                    icon: "success",
                    title: "Tải lên tệp",
                    text: "Tệp: " + this.fileNameTemplate + " đã tải lên thành công!",
                  });
                } else {
                  this.$swal.fire({
                    icon: "error",
                    title: "Tải lên tệp",
                    html: "Tệp: " + this.fileNameTemplate + " tải lên lỗi: " + res.data.status,
                  });
                }
                this.isUploadingTemplate = false;
              })
              .catch((error) => {
                this.$swal.fire({
                  icon: "error",
                  title: "Tải lên tệp",
                  html: "Tệp: " + this.fileNameTemplate + " tải lên lỗi: " + error,
                });
                this.isUploadingTemplate = false;
              });
          }
        }
      })
    },
    onFileChangeTemplate(event) {
      this.selectedFileTemplate = event.target.files[0];
      if (this.selectedFileTemplate) {
        this.fileNameTemplate = this.selectedFileTemplate.name;
        // console.log('selected file name:', this.fileNameTemplate)
      } else {
        // console.log('no file selected');
        this.fileNameTemplate = 'Duyệt tệp'
      }
    },
    handleSubmitImport() {
      if (!this.selectedFileImport) {
        this.$swal.fire({
          icon: "error",
          title: "Tải lên",
          text: "Vui lòng chọn tệp trước"
        });
        return;
      }

      this.$swal.fire({
        title: "Nhập thao tác",
        input: "text",
        inputPlaceholder: "Nhập thao tác...",
        showCancelButton: true,
      }).then((result) => {
        if (result.isConfirmed && result.value) {
          if(result.value.toLowerCase() !== 'nhap kho') {
            this.$swal.fire({
              icon: "error",
              title: "Nhập thao tác",
              text: "Thao tác không hợp lệ!"
            });
          } else {
            // Create FormData instance to hold the file
            this.isUploadingImport = true;
            const formData = new FormData();
            formData.append("file", this.selectedFileImport);
            // Send file using Axios
            this.$request.post("/api/repo/importfromfile", formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }).then((res) => {
              if (res.data.status === 'success') {
                // console.log(res.data.status)
                this.$swal.fire({
                  icon: "success",
                  title: "Tải lên tệp",
                  text: "Tệp: " + this.fileNameImport + " đã tải lên thành công!",
                });
              } else {
                this.$swal.fire({
                  icon: "error",
                  title: "Tải lên tệp",
                  html: "Tệp: " + this.fileNameImport + " tải lên lỗi: " + res.data.status,
                });
              }
              this.isUploadingImport = false;
            }).catch((error) => {
              this.$swal.fire({
                icon: "error",
                title: "Tải lên tệp",
                html: "Tệp: " + this.fileNameImport + " tải lên lỗi: " + error,
              });
              this.isUploadingImport = false;
            });
          }
        }
      });


    },
    onFileChangeImport(event) {
      this.selectedFileImport = event.target.files[0];
      if (this.selectedFileImport) {
        this.fileNameImport = this.selectedFileImport.name;
        // console.log('selected file name:', this.fileNameImport)
      } else {
        // console.log('no file selected');
        this.fileNameImport = 'Duyệt tệp'
      }
    },
    handleSubmitExport() {
      if (!this.selectedFileExport) {
        this.$swal.fire({
          icon: "error",
          title: "Tải lên",
          text: "Vui lòng chọn tệp trước"
        });
        return;
      }

      this.$swal.fire({
        title: "Nhập thao tác",
        input: "text",
        inputPlaceholder: "Nhập thao tác...",
        showCancelButton: true,
      }).then((result) => {
        if (result.isConfirmed && result.value) {
          if (result.value.toLowerCase() !== 'xuat kho') {
            this.$swal.fire({
              icon: "error",
              title: "Nhập thao tác",
              text: "Thao tác không hợp lệ!"
            });
          } else {
            // Create FormData instance to hold the file
            this.isUploadingExport = true;
            const formData = new FormData();
            formData.append("file", this.selectedFileExport);
            // Send file using Axios
            this.$request.post("/api/repo/exportfromfile", formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }).then((res) => {
              if (res.data.status === 'success') {
                // console.log(res.data.status)
                this.$swal.fire({
                  icon: "success",
                  title: "Tải lên tệp",
                  text: "Tệp: " + this.fileNameExport + " đã tải lên thành công!",
                });
              } else {
                this.$swal.fire({
                  icon: "error",
                  title: "Tải lên tệp",
                  html: "Tệp: " + this.fileNameExport + " tải lên lỗi: " + res.data.status,
                });
              }
              this.isUploadingExport = false;
            })
              .catch((error) => {
                this.$swal.fire({
                  icon: "error",
                  title: "Tải lên tệp",
                  html: "Tệp: " + this.fileNameExport + " tải lên lỗi: " + error,
                });
                this.isUploadingExport = false;
              });
          }
        }
      })
    },
    onFileChangeExport(event) {
      this.selectedFileExport = event.target.files[0];
      if (this.selectedFileExport) {
        this.fileNameExport = this.selectedFileExport.name;
        // console.log('selected file name:', this.fileNameExport)
      } else {
        // console.log('no file selected');
        this.fileNameExport = 'Duyệt tệp'
      }
    },
    createBuyBom() {
      // console.log('createBuyBom');
      this.$router.push({
        path: '/component/search',
        query: {
          request: 'bill'
        }
      })
    }
  },
};
</script>
